/** Max fractional digits in Place Order inputs; also used when pair decimals are 0. */
export const PLACE_ORDER_MAX_DECIMALS = 4;

/** Soft max integer digits for price/qty inputs (not tied to JS MAX_SAFE_INTEGER). */
export const PLACE_ORDER_MAX_INTEGER_DIGITS = 24;

/** int digits + '.' + fraction digits */
export const PLACE_ORDER_PRICE_MAX_LENGTH =
  PLACE_ORDER_MAX_INTEGER_DIGITS + 1 + PLACE_ORDER_MAX_DECIMALS;

export const WHITELIST_POLL_INTERVAL_MS = 30_000;

export const WHITELIST_STATUS = {
  NOT_SUBMITTED: 'not_submitted',
  SUBMITTED: 'submitted',
  APPROVED: 'approved',
};

export const WHITELIST_PENDING = {
  FETCH_PAIR: 'fetch_pair',
  FETCH_WALLET: 'fetch_wallet',
  SUBSCRIBE: 'subscribe',
};
